import { render, staticRenderFns } from "./title-desc-tutorial.vue?vue&type=template&id=52046c65"
import script from "./title-desc-tutorial.vue?vue&type=script&lang=js"
export * from "./title-desc-tutorial.vue?vue&type=script&lang=js"
import style0 from "./title-desc-tutorial.vue?vue&type=style&index=0&id=52046c65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.104.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports